import ApiFetchers from "@/apis/api_fetchers"
import { createRepository } from "@/utils/zustand"

const [useUserInfo, _state_atoms_userInfo] = createRepository(ApiFetchers.refGetProfile, {
    authRequired: true,
    persist: true,
    key: "userInfo",
    persistOptions: {
        storage: localStorage,
    },
})
const [useKyc, _state_atoms_kyc] = createRepository(ApiFetchers.getKyc, {
    authRequired: true,
    persist: true,
    key: "kyc",
    persistOptions: {
        storage: localStorage,
    },
})

const [useRefGetProfile, _state_atoms_refGetProfile] = createRepository(
    () => ApiFetchers.refGetProfile().then((res) => res ?? {}),
    {
        authRequired: true,
    },
)

const [useRefGetFinanceWallet, _state_atoms_refGetFinanceWallet] = createRepository(
    () => ApiFetchers.refGetFinanceWallet().then((res) => res ?? {}),
    {
        authRequired: true,
    },
)

const base = {
    useRefGetFinanceWallet,
    useRefGetProfile() {
        const userInfo = useRefGetProfile()
        return {
            data: userInfo.data,
            fetch: userInfo.fetch,
            loading: userInfo.state.loading,
            error: userInfo.state.error,
        }
    },
    useUserInfo() {
        const userInfo = useUserInfo()
        return {
            data: userInfo.data,
            fetch: userInfo.fetch,
            loading: userInfo.state.loading,
            error: userInfo.state.error,
        }
    },
    useKyc() {
        const kycInfo = useKyc()
        return {
            data: kycInfo.data,
            fetch: kycInfo.fetch,
            loading: kycInfo.state.loading,
            error: kycInfo.state.error,
        }
    },
    useKycFlat() {
        const _data = useKyc()
        return {
            data: _data.data,
            fetch: _data.fetch,
            loading: _data.state.loading,
            error: _data.state.error,
        }
    },
}

export const Repository = {
    ...base,
}
